import React, { useContext } from "react";

//Context
// import { UserContext } from "./../../state/user/userContext";
import { GlobalContext } from "./../../state/global/globalContext";

//Component

import "./style.scss";

//Assets
import Logo from "./../../assets/Main_Logo.png";

const Header = () => {
    //Use context
    // const { state, dispatch } = useContext(UserContext);
    const { isToggle, setIsToggle } = useContext(GlobalContext);

    return (
        <div className="header">
            <img
                src={Logo}
                alt="Logo"
                onClick={() => {
                    setIsToggle(!isToggle);
                }}
            />
            <div
                className="header-title"
                onClick={() => {
                    setIsToggle(!isToggle);
                }}
            >
                Yona Web Wallet
            </div>
        </div>
    );
};
export default Header;
